<template>
	<div class="grid-flex-container mx-2">
		<v-container fluid class="py-6">
			<v-row class="mb-6">
				<div style="flex-grow: 1">
					<v-text-field
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn color="primary" @click="addProject()">
						<v-icon> mdi-plus</v-icon>
						&nbsp;&nbsp;Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<div class="generic-grid-container">
			<v-data-table
				:headers="headers"
				:items="items"
				:search.sync="search"
				:sort-desc="[true]"
				:loading="loading"
				:disable-pagination="true"
				hide-default-footer
				multi-sort
				dense
				fixed-header
			>
				<template v-slot:[`item.MobileStatus`]="{ item }">
					<v-chip x-small :color="mobileStatusColor(item)" dark>
						{{ mobileStatus(item) }}
					</v-chip>
				</template>
				<template v-slot:[`item.actions`]="{ item }">
					<div class="d-flex">
						<v-spacer />
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="success"
							@click="editProject(item)"
						>
							<v-icon small> mdi-pencil </v-icon>
						</v-btn>
						<v-btn
							class="action-btn"
							fab
							small
							icon
							elevation="1"
							color="error"
							@click="deleteProject(item.Id)"
						>
							<v-icon small> mdi-delete</v-icon>
						</v-btn>
					</div>
				</template>
			</v-data-table>
		</div>
	</div>
</template>
<script>
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { mapGetters } from 'vuex';
import { ProjectManagementActions } from '../../store/actions';
import { ProjectManagementGetters } from '../../store/getters';
import { Permissions } from '../../enums/permissionsEnum';
import permissionsMixin from '../../mixins/permissionsMixin';
export default {
	name: 'ProjectsView',
	mixins: [permissionsMixin],
	data() {
		return {
			dialog: false,
			search: '',
			showProjectModal: false,
		};
	},
	computed: {
		...mapGetters({
			items: [ProjectManagementGetters.GET_DATA],
			loading: [ProjectManagementGetters.GRID_LOADING],
		}),
		canViewProjectId() {
			return this.hasPermissions([
				Permissions.ProjectManagement.CanViewProjectId,
			]);
		},
		headers() {
			let result = [
				{
					text: 'Name',
					value: 'Name',
				},
				{
					text: 'Description',
					value: 'Description',
				},
			];
			if (this.canViewProjectId)
				result.push({ text: 'Project ID', value: 'Id' });
			result.push({
				sortable: false,
				text: 'Mobile',
				value: 'MobileStatus',
			});
			result.push({ sortable: false, text: '', value: 'actions' });
			return result;
		},
	},
	mounted() {
		this.loadData();
	},
	destroyed() {
		this.$store.dispatch(ProjectManagementActions.CLEAR);
	},
	methods: {
		deleteProject(id) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this project?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$store
						.dispatch(ProjectManagementActions.DELETE, id)
						.then(() => this.loadData());
				}
			});
		},
		addProject() {
			this.$router.push({
				name: 'ProjectsManagementAdd',
				params: { id: null },
			});
		},
		editProject(item) {
			this.$router.push({
				name: 'ProjectsManagementEdit',
				params: { id: item.Id },
			});
		},
		loadData() {
			this.$store.dispatch(ProjectManagementActions.LOAD_DATA);
		},
		mobileStatus(item) {
			if (!item.MobileAccessEnabled) return 'Disabled';
			const now = new Date();
			if (item.ValidFrom && new Date(item.ValidFrom) > now)
				return 'Not started';
			if (!item.ValidUntil) return 'Active';

			const validUntil = new Date(item.ValidUntil);
			if (validUntil < now) return 'Expired';

			const daysLeft = Math.ceil(
				(validUntil - now) / (1000 * 60 * 60 * 24)
			);
			return daysLeft <= 14 ? `Ends in ${daysLeft}d` : 'Active';
		},
		mobileStatusColor(item) {
			const status = this.mobileStatus(item);
			if (status === 'Expired' || status === 'Disabled') return 'error';
			if (status.startsWith('Ends in')) return 'warning';
			if (status === 'Not started') return 'grey';
			return 'success';
		},
	},
};
</script>
